import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type LoginState = Partial<{
	accountId: string;
	instituteId: string;
	ssoRegistrationId: string;
	passwordRestToken: string;
	rememberMe: boolean;
}>;

const initialState: LoginState = {};

const loginSlice = createSlice({
	name: "login",
	initialState,
	reducers: {
		setInstituteId: (state, action: PayloadAction<string>) => {
			state.instituteId = action.payload;
		},
		setSsoRegistrationId: (state, action: PayloadAction<string>) => {
			state.ssoRegistrationId = action.payload;
		},
		setPasswordRestToken: (state, action: PayloadAction<string>) => {
			state.passwordRestToken = action.payload;
		},
		setAccountId: (state, action: PayloadAction<string>) => {
			state.accountId = action.payload;
		},
		setRememberMe: (state, action: PayloadAction<boolean>) => {
			state.rememberMe = action.payload;
		},
	},
});

export const { setInstituteId, setSsoRegistrationId, setPasswordRestToken, setAccountId, setRememberMe } =
	loginSlice.actions;
export default loginSlice.reducer;
